<template>
  <div class="back-to-school-banner pa-5">
    <div class="back-to-school-banner-title d-block">
      <span class="d-inline mr-1">
        {{ $t('banners.backToSchool.title') }}
      </span>
      <cool-icon class="d-inline" />
    </div>

    <div
      class="back-to-school-banner-description mt-2"
      v-html="$t('banners.backToSchool.text')"
    />

    <v-btn
      color="white"
      class="align-self-end back-to-school-banner-luck-button"
      @click="handleTryYourLuck"
      height="40"
      elevation="0"
    >
      <span>{{ $t('banners.backToSchool.btn') }}</span>
    </v-btn>

    <v-btn
      icon
      color="white"
      class='back-to-school-banner-luck-button-close-button'
      @click="handleCloseBackToSchoolBanner"
    >
      <cross />
    </v-btn>
  </div>
</template>

<script>
import CoolIcon from '@/assets/icons/variants/cool.vue'
import Cross from '@/assets/icons/variants/16/cross.vue'

export default {
  name: 'BackToSchoolBanner',
  components: {
    Cross,
    CoolIcon,
  },
  methods: {
    handleTryYourLuck() {
      window.open('https://t.me/dolphin_anty_news/575', '_blank')
    },

    async handleCloseBackToSchoolBanner () {
      try {
        this.$store.dispatch('main/hideBanner',  'backToSchool')
        await this.api.post('/profile/quiz', { quizId: 4 })
      } catch (err) {
        console.error(err)
      }
    }
  }
}
</script>

<style lang='scss'>
.back-to-school-banner {
  position: relative;
  margin-top: 46px;
  margin-left: 12px;
  border-radius: 12px;
  background: var(--Gradients-Purple-Blue, linear-gradient(106deg, #9B26B6 0%, #19AFFF 137.11%));
  width: 100%;
  display: flex;
  flex-direction: column;
}
.back-to-school-banner-title {
  color: white;
  font-family: Roboto;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px;

  * {
    vertical-align: text-top;
  }
}
.back-to-school-banner-description {
  color: white;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%;

  strong {
    font-weight: 600;
  }
}

.back-to-school-banner-luck-button {
  z-index: 10;
  border-radius: 8px;
}

.back-to-school-banner-luck-button span {
  color: #28334a;
  letter-spacing: 0;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  text-transform: none;
}

.back-to-school-banner-luck-button-close-button {
  position: absolute;
  padding: 8px;
  right: 8px;
  top: 8px;
  z-index: 10;
}
</style>
